export const about = {
  seo: {
    title: '關於我們 | LensBank 專業器材租賃',
    description: '十多年專業器材租賃經驗，與金馬影展合作的信賴品牌。提供台日拍攝協作、專業團隊支援，是您影像創作的最佳夥伴。',
    keywords: '關於LensBank,器材租賃公司,台日合作,金馬影展,專業團隊'
  },
  hero: {
    title: '關於我們',
    subtitle: '專業器材租賃的領導品牌',
  },
  story: {
    title: '我們的故事',
    content: 'LensBank 成立於 2008 年，專注於提供專業攝影器材租賃服務。十多年來，我們累積了豐富的經驗，並與金馬影展等重要影視活動建立長期合作關係。我們不僅提供器材，更提供專業的技術支援與諮詢服務，成為影像創作者最信賴的夥伴。'
  },
  milestones: {
    title: '重要里程碑',
    items: [
      {
        year: '2008',
        title: '公司成立',
        desc: '在台中成立第一家門市，開始專業器材租賃服務'
      },
      {
        year: '2010',
        title: '多據點擴展',
        desc: '在台中、台南設立據點，服務範圍擴及全台'
      },
      {
        year: '2013',
        title: '金馬影展合作',
        desc: '成為金馬影展合作廠商，開啟長期影展合作關係'
      },
      {
        year: '2016',
        title: '台日協作',
        desc: '建立台日拍攝協作服務，提供跨境拍攝全方位支援'
      },
      {
        year: '2023',
        title: 'Urent 服務',
        desc: '推出 Urent 寄租服務，讓閒置器材創造價值'
      }
    ]
  },
  values: {
    title: '我們的價值',
    items: [
      {
        title: '專業品質',
        desc: '嚴格把關每一件器材，確保最佳使用狀態'
      },
      {
        title: '客戶至上',
        desc: '提供專業諮詢與技術支援，解決拍攝難題'
      },
      {
        title: '創新服務',
        desc: '持續開發新服務，滿足多元化的拍攝需求'
      },
      {
        title: '信賴夥伴',
        desc: '與客戶建立長期合作關係，共同成長'
      }
    ]
  },
  team: {
    title: '專業團隊',
    desc: '我們擁有經驗豐富的專業團隊，包括器材管理專家、技術支援人員、以及拍攝協調人員。團隊成員具備豐富的影視製作經驗，能夠提供最專業的建議與協助。'
  },
  capabilities: {
    title: '服務能力',
    items: [
      '超過 1,000+ 件專業攝影器材',
      '4 個服務據點（門市 + 倉庫）',
      '台日跨境拍攝協作',
      '專業技術支援團隊',
      '人員出班攝製服務',
      '客製化拍攝解決方案'
    ]
  }
};